export default __webpack_public_path__ + "static/media/953.b1195555.png";